// extracted by mini-css-extract-plugin
export default {"Toolbar":"Toolbar_Toolbar__m5si2","logo":"Toolbar_logo__MDpVD","DesktopOnly":"Toolbar_DesktopOnly__Pdgks","MobileOnly":"Toolbar_MobileOnly__bGMQM"};